import { motion, AnimatePresence } from "framer-motion";
import { ChatInterface } from "./ChatInterface";
import { useIsMobile } from "@/hooks/use-mobile";

interface ChatModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ChatModal({ isOpen, onClose }: ChatModalProps) {
  const isMobile = useIsMobile();

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop - only on mobile */}
          {isMobile && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-40 bg-background/80 backdrop-blur-sm"
              onClick={onClose}
            />
          )}

          {/* Modal */}
          <motion.div
            initial={isMobile ? { y: "100%" } : { opacity: 0, y: 20, scale: 0.95 }}
            animate={isMobile ? { y: 0 } : { opacity: 1, y: 0, scale: 1 }}
            exit={isMobile ? { y: "100%" } : { opacity: 0, y: 20, scale: 0.95 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            whileHover={isMobile ? undefined : { boxShadow: "0 8px 40px -8px hsl(0 25% 65% / 0.4)" }}
            className={
              isMobile
                ? "fixed inset-0 z-50 bg-background"
                : "fixed bottom-24 right-6 z-50 h-[600px] w-[400px] overflow-hidden rounded-2xl border border-border bg-background shadow-2xl transition-shadow duration-300"
            }
          >
            <ChatInterface onClose={onClose} />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
